import React, { Component } from 'react'
import { Redirect } from 'react-router'

import { isValidLin } from 'app/utils/validations'

export class AppraisalSearchBar extends Component {
  constructor(props) {
    super(props)

    this.state = {
      searchValue: '',
      location: null,
      searchValid: true,
      invalidMessage: ''
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleInvalid = this.handleInvalid.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.location)
      this.setState({
        location: null
      })
    if (this.props.location !== prevProps.location) {
      this.setState({
        searchValid: true,
        invalidMessage: ''
      })
    }
  }

  handleChange(event) {
    let digits = event.target.value.replace(/(\D)*/, '')
    let formatted = digits.replace(/(\d{2})+?(\d{2})+?(\d{1})+?(\d{7})+?/, (match, p1, p2, p3, p4) => {
      let output = ''
      if (p1) { output = `${p1}-` }
      if (p2) { output += `${p2}-` }
      if (p3) { output += `${p3}-` }
      if (p4) { output += `${p4}` }
      return output
    })

    this.setState({
      searchValue: formatted,
      searchValid: true
    })
  }

  handleSubmit(event) {
    event.preventDefault()
    let location = `/lgyhub/appraiser/search/${this.state.searchValue}`
    this.setState({ searchValue: '', location: location })
  }

  handleInvalid(event) {
    event.preventDefault()
    if (event.target.value === '') {
      this.setState({
        invalidMessage: 'LIN may not be blank.',
        searchValid: false
      })
    } else if (isValidLin(event?.target?.value?.trim())) {
        this.setState({
          invalidMessage: 'The LIN required is not a valid VA Loan ID Number (LIN).',
          searchValid: false
        })
      } else {
      this.setState({
        invalidMessage: 'Invalid LIN ID.',
        searchValid: false
      })
    }
  }

  render() {
    if (this.state.location && this.state.location !== this.props.location.pathname) {
      return (<Redirect push to={this.state.location} />)
    }

    return (
      <div className='appraisal-search-bar'>
        <form className='usa-search usa-search-small' onSubmit={this.handleSubmit}>
          <label htmlFor='search'>
            Find assignments by LIN:
            <input
              id='search'
              type='search'
              value={this.state.searchValue}
              onChange={this.handleChange}
              placeholder='xx-xx-x-xxxxxxx'
              pattern='(\d{2}-)+?(\d{2}-)+?(\d{1}-)+?(\d{7})+?'
              maxLength='15'
              required
              aria-required
              onInvalid={this.handleInvalid} />
            <button type='submit' aria-label='Find assignments by LIN' value={this.state.searchValue} />
          </label>
          <span className='usa-input-error-message' style={{ fontSize: '1.5rem' }} id='input-error-message' role='alert' hidden={this.state.searchValid}>
            {this.state.invalidMessage}
          </span>
        </form>
      </div >
    )
  }
}

export default AppraisalSearchBar
